import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Filled } from '../../primitives/Chip/components/Filled.js';
import { Label } from '../../primitives/Chip/components/Label.js';
import { Outlined } from '../../primitives/Chip/components/Outlined.js';
import { RemoveIcon } from '../../primitives/Chip/components/RemoveIcon.js';
export const Chip = /*#__PURE__*/_styled(forwardRef(({
  variant = 'filled',
  size = 'medium',
  label,
  active = false,
  disabled = false,
  icon,
  onClick,
  onClickRemove,
  ...restProps
}, ref) => {
  const Component = variant === 'filled' ? Filled : Outlined;
  const clickable = typeof onClick === 'function';
  const removeable = typeof onClickRemove === 'function';
  const withIcon = Boolean(icon);
  return _jsxs(Component, {
    ...restProps,
    ref: ref,
    variant: variant,
    size: size,
    active: active,
    disabled: disabled,
    clickable: clickable,
    removeable: removeable,
    withIcon: withIcon,
    tabIndex: clickable ? 0 : undefined,
    onClick: !disabled ? onClick : undefined,
    children: [icon, _jsx(Label, {
      "data-label": label,
      children: label
    }), removeable && _jsx(RemoveIcon, {
      tabIndex: 0,
      "data-testid": "removeIcon",
      onClick: !disabled ? onClickRemove : undefined
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "eucbruu0"
} : {
  target: "eucbruu0",
  label: "Chip"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoaXAuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYUkiLCJmaWxlIjoiQ2hpcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgRmlsbGVkIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9DaGlwL2NvbXBvbmVudHMvRmlsbGVkLmpzJztcbmltcG9ydCB7IExhYmVsIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9DaGlwL2NvbXBvbmVudHMvTGFiZWwuanMnO1xuaW1wb3J0IHsgT3V0bGluZWQgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0NoaXAvY29tcG9uZW50cy9PdXRsaW5lZC5qcyc7XG5pbXBvcnQgeyBSZW1vdmVJY29uIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9DaGlwL2NvbXBvbmVudHMvUmVtb3ZlSWNvbi5qcyc7XG5leHBvcnQgY29uc3QgQ2hpcCA9IHN0eWxlZChmb3J3YXJkUmVmKCh7IHZhcmlhbnQgPSAnZmlsbGVkJywgc2l6ZSA9ICdtZWRpdW0nLCBsYWJlbCwgYWN0aXZlID0gZmFsc2UsIGRpc2FibGVkID0gZmFsc2UsIGljb24sIG9uQ2xpY2ssIG9uQ2xpY2tSZW1vdmUsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IHtcbiAgICBjb25zdCBDb21wb25lbnQgPSB2YXJpYW50ID09PSAnZmlsbGVkJyA/IEZpbGxlZCA6IE91dGxpbmVkO1xuICAgIGNvbnN0IGNsaWNrYWJsZSA9IHR5cGVvZiBvbkNsaWNrID09PSAnZnVuY3Rpb24nO1xuICAgIGNvbnN0IHJlbW92ZWFibGUgPSB0eXBlb2Ygb25DbGlja1JlbW92ZSA9PT0gJ2Z1bmN0aW9uJztcbiAgICBjb25zdCB3aXRoSWNvbiA9IEJvb2xlYW4oaWNvbik7XG4gICAgcmV0dXJuIChfanN4cyhDb21wb25lbnQsIHsgLi4ucmVzdFByb3BzLCByZWY6IHJlZiwgdmFyaWFudDogdmFyaWFudCwgc2l6ZTogc2l6ZSwgYWN0aXZlOiBhY3RpdmUsIGRpc2FibGVkOiBkaXNhYmxlZCwgY2xpY2thYmxlOiBjbGlja2FibGUsIHJlbW92ZWFibGU6IHJlbW92ZWFibGUsIHdpdGhJY29uOiB3aXRoSWNvbiwgdGFiSW5kZXg6IGNsaWNrYWJsZSA/IDAgOiB1bmRlZmluZWQsIG9uQ2xpY2s6ICFkaXNhYmxlZCA/IG9uQ2xpY2sgOiB1bmRlZmluZWQsIGNoaWxkcmVuOiBbaWNvbiwgX2pzeChMYWJlbCwgeyBcImRhdGEtbGFiZWxcIjogbGFiZWwsIGNoaWxkcmVuOiBsYWJlbCB9KSwgcmVtb3ZlYWJsZSAmJiAoX2pzeChSZW1vdmVJY29uLCB7IHRhYkluZGV4OiAwLCBcImRhdGEtdGVzdGlkXCI6IFwicmVtb3ZlSWNvblwiLCBvbkNsaWNrOiAhZGlzYWJsZWQgPyBvbkNsaWNrUmVtb3ZlIDogdW5kZWZpbmVkIH0pKV0gfSkpO1xufSkpIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q2hpcC5qcy5tYXAiXX0= */");